export default __webpack_public_path__ + "static/media/I0002.53a03853.png";